import * as React from "react"
import {Grid, Typography, Box} from "@mui/material";
import {CardSeeker, IconSeeker} from "@ui-seeker/core";
import {isEmpty} from "@ui-seeker/utils";


import {usePriceEvolutionWidgetPricing} from "../../@hooks";
import {ORDER_WIDGET_BY} from "../../@contants";
import { PriceEvolutionCurrentTabId } from "../../@signals";
import PriceEvolutionWidgetLoadingBlock from "./LoadingBlock";
import PriceEvolutionWidgetLegend from "./Legend";
import PriceEvolutionWidgetRetailerBlock from "./RetailerBlock";
import PriceEvolutionWidgetSkuBlock from "./SkuBlock";
import PriceEvolutionWidgetActions from "./Actions";
import PriceEvolutionNoSkuDataBlock from "./NoSkuDataBlock";



export default function PriceEvolutionWidget() {
	const {
		allData, currentDataMinMax, currentData, isSplitBySku, showListPrice, isLoading, isPercentage, selectedLabel, handleShowListPrice,
		orderBy, handleOrder
	} = usePriceEvolutionWidgetPricing()

	if (isLoading)
		return <PriceEvolutionWidgetLoadingBlock />
	
	if (PriceEvolutionCurrentTabId.value && isEmpty(currentData))
		return <PriceEvolutionNoSkuDataBlock />

	if (isEmpty(currentData))
		return <></>

	const { avgWidgets=[] } = currentData
	avgWidgets.sort((a, b) => {
		if (orderBy === ORDER_WIDGET_BY.NAME)
			return a.label.localeCompare(b.label)
		else {
			const aValue = showListPrice ? a.listKPI : a.actualKPI
			const bValue = showListPrice ? b.listKPI : b.actualKPI
			return isPercentage ? bValue - aValue : aValue - bValue
		}
	})

	return <CardSeeker
		title={`Retailer ${isPercentage ? 'Discount' : 'Price'} Overview - ${selectedLabel}`}
		actions={<PriceEvolutionWidgetActions
			isPercentage={isPercentage}
			isSplitBySku={isSplitBySku}
			showListPrice={showListPrice}
			orderBy={orderBy}
			handleShowListPrice={handleShowListPrice}
			handleOrder={handleOrder}
		/>}
	>
		<Grid container spacing={2}>
			<Grid item xs={3}>
				<PriceEvolutionWidgetLegend
					isPercentage={isPercentage}
					isSplitBySku={isSplitBySku}
				/>
			</Grid>

			{ !!avgWidgets.length && isSplitBySku
				? <PriceEvolutionWidgetRetailerBlock
					data={avgWidgets}
					isPercentage={isPercentage}
					useListPrice={showListPrice}
					dataMinMax={currentDataMinMax}
				/> : <PriceEvolutionWidgetSkuBlock
					data={avgWidgets}
					isPercentage={isPercentage}
					useListPrice={showListPrice}
					dataMinMax={currentDataMinMax}
				/>
			}

		</Grid>
	</CardSeeker>
}